import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import Logo from '../../Images/Logo.webp'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { removePurchasePlan } from '../../DataStore/Slices/purchaseSlice'
import PricingPlan from '../PricingPlan'
import { payment, retailer } from '../Models/AccountModel'
import server from '../../Backend/axios'
import { selectUser } from '../../DataStore/Slices/userSlice'
import { useSelector } from 'react-redux'
import CheckUserProvider from '../../AllHooks/CheckUserProvider'

function ChoosePricing() {
  const history = useHistory()
  const user = useSelector(selectUser)
  const dispatch = useDispatch()
  const { userData } = CheckUserProvider()
  const [isFreeTrailButtonVisible, setIsFreeTrailButtonVisible] = useState(false)

  useEffect(async () => {
    if (userData) {
      await server
        .get(`/Payment/GetPaymentDetailsByEmpIdAsync/${userData.uid}`)
        .then((resp) => {
          if (resp.status === 200 && resp.data.message === 'success') {
            // var isTrail = false;
            // if (planName === 'Freetrial') {
            //   if (resp.data.data.isExpire) {
            //     isTrail = Boolean(resp.data.data.isExpire)
            //     setIsFreeTrailButtonVisible(isTrail);
            //   } else {
            //     isTrail = Boolean(resp.data.data.isExpire)
            //     setIsFreeTrailButtonVisible(!isTrail);
            //   }
            // } else {
            //   isTrail = Boolean(resp.data.data.isExpire)
            //   setIsFreeTrailButtonVisible(isTrail);
            // }

            var isTrail = Boolean(resp.data.data.isExpire)
            setIsFreeTrailButtonVisible(isTrail);
          }
        })
        .catch((err) => console.error(err.message))
    } else {
      setIsFreeTrailButtonVisible(false);
    }
  }, [userData]);

  const handleBuyNow = async (name, amount, isFreeTrail = false) => {
    if (user.user || userData) {
      var commonUid = null
      if (userData) {
        payment.uid = userData.uid
        commonUid = userData.uid
      } else {
        payment.uid = user.user.uid
        commonUid = user.user.uid
      }
      payment.planName = name
      payment.planPrice = String(amount)
      payment.isFreeTrail = isFreeTrail
      if (name && name !== 'Ultimate') {
        retailer.isPlanActivated = true;
      }
      await server
        .post('/Account/UpdatePaymentDetailsAsync', {
          retailer: retailer,
          payment: payment,
        })
        .then(async (res) => {
          if (res.status === 200) {
            if (name === 'Ultimate' && !isFreeTrail) {
              dispatch(removePurchasePlan())
              history.push(`/payment-page/${commonUid}`)
            } else {
              await server
                .get(`/Account/ActivatePlanAsync?uid=${payment.uid}`)
                .then((resp) => {
                  if (resp.status === 200) {
                    if (resp.data.message === 'success') {
                      dispatch(removePurchasePlan())
                      history.push('/activity/dashboard')
                    }
                  }
                })
                .catch((err) => console.log(err.message))
            }
          }
        })
        .catch((err) => console.log(err.message))
    }
  }

  return (
    <>
      <div className="container-fluid registerRetailer">
        <div className="row">
          <div className="col-10 mx-auto">
            <div className="row">
              <div className="col-md-12 text-center">
                <NavLink className="" to="/">
                  <img className="img-fluid" src={Logo} alt="Website Logo" width="200px" />
                </NavLink>
                <h5 className="registerEmp__pageTitle">
                  <span>Plan Details</span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-1">
        <PricingPlan
          handleBuyNow={handleBuyNow}
          isFreeTrailButtonVisible={isFreeTrailButtonVisible}
        />
      </div>
    </>
  )
}

export default ChoosePricing
